export const templatesIndex = {
  header: {
    title: "WhatsApp-Vorlagen",
    description:
      "Erstellen und bearbeiten Sie Vorlagen wie in Meta (Kopfzeile/Text/Fußzeile/Buttons + Vorschau).",
    create: "Vorlage erstellen",
  },
  notConnected:
    'Mit Ihrem Konto ist kein WhatsApp Business (WABA) verbunden. Verbinden Sie es zuerst unter "WhatsApp Business".',
  filters: {
    search: "Suchen",
    searchPlaceholder: "Nach Namen suchen...",
    status: "Status",
    all: "Alle",
    category: "Kategorie",
    allFem: "Alle",
    language: "Sprache",
    refresh: "Aktualisieren",
  },
  list: {
    loading: "Vorlagen werden geladen...",
    emptyTitle: "Keine Vorlagen",
    emptyText: "Ändern Sie die Filter oder erstellen Sie Ihre erste Vorlage.",
    baseBadge: "Basis",
    edit: "Bearbeiten",
    duplicate: "Duplizieren",
    deleteProtected: "Basisvorlage: kann nicht gelöscht werden",
    delete: "Löschen",
    prev: "← Zurück",
    next: "Weiter →",
  },
  preview: {
    noText: "(kein Text)",
    noContent: "Kein Inhalt",
  },
  time: {
    now: "Jetzt",
    minutesAbbr: "{n} Min.",
    hoursAbbr: "{n} Std.",
  },
  common: {
    close: "Schließen",
    cancel: "Abbrechen",
  },
  editor: {
    createTitle: "Vorlage erstellen",
    editTitle: "Vorlage bearbeiten",
    sectionBasic: "Basis",
    name: "Name (snake_case)",
    nameHintHtml:
      "Leerzeichen werden zu <code>_</code>. Nur <code>a-z</code>, <code>0-9</code> und <code>_</code>.",
    language: "Sprache",
    category: "Kategorie",
    sectionHeader: "Kopfzeile",
    enable: "Aktivieren",
    type: "Typ",
    headerLocationHintHtml:
      "Eine LOCATION-Kopfzeile enthält in der Vorlage weder Text noch Beispiele. Der Standort (Breiten-/Längengrad + Name/Adresse) wird beim Versand der Nachricht über <code>/messages</code> übermittelt.",
    headerMediaHint:
      "Wenn Sie MEDIA verwenden, verlangt Ihr Konto bei der Prüfung möglicherweise Beispiele/Handles.",
    headerTextLabel: "Text (max. 60)",
    headerTextPlaceholder: "Z. B. Hallo {{1}}, Ihre Buchung ist bereit.",
    insert: "Einfügen",
    autoExample: "Beispiel automatisch",
    examplesHeader: "Beispiele (Kopfzeile)",
    remove: "Entfernen",
    headerLocationNote: "Am Anfang der Nachricht wird eine Kartenkarte gesendet.",
    headerMediaNote: "Diese Kopfzeile wird als Anhang (Media) angezeigt.",
    sectionBody: "Text",
    bodyPlaceholder: "Schreiben Sie den Inhalt. Verwenden Sie {{1}}, {{2}}...",
    examplesBody: "Beispiele (Text)",
    sectionFooter: "Fußzeile",
    footerPlaceholder: "Kurzer Text (optional, max. 60)",
    sectionButtons: "Buttons",
    addButton: "+ Hinzufügen",
    noButtons: "Keine Buttons (optional).",
    buttonTextPlaceholder: "Button-Text (max. 25)",
    removeButton: "Löschen",
    previewTitle: "Vorschau",
    viewPayload: "An Meta gesendete Payload ansehen",
    metaDebug: "Antwort/Fehler von Meta (Debug)",
    validReady: "Bereit zum Speichern.",
    validIncomplete: "Füllen Sie vor dem Speichern die Pflichtfelder aus.",
    saving: "Wird gespeichert...",
    save: "Speichern",
  },
  delete: {
    title: "Vorlage löschen",
    irreversible: "Diese Aktion kann nicht rückgängig gemacht werden.",
    willDeletePre: "Die Vorlage ",
    willDeletePost: " wird gelöscht.",
    confirmLabel: "Geben Sie zur Bestätigung den genauen Namen ein:",
    confirmPlaceholder: "Namen exakt eingeben",
    confirmHint: "Der Button wird aktiviert, wenn der Text exakt übereinstimmt.",
    deleting: "Wird gelöscht...",
    confirmDelete: "Endgültig löschen",
  },
  errors: {
    nameRequired: "Der Name ist erforderlich.",
    nameInvalid: "Ungültiges Format. Verwenden Sie nur a-z, 0-9 und _.",
    headerRequired: "Der Text der Kopfzeile ist erforderlich, wenn die Kopfzeile aktiviert ist.",
    headerMax: "Der Text der Kopfzeile darf höchstens 60 Zeichen lang sein.",
    bodyRequired: "Der Text ist erforderlich.",
    bodyMax: "Der Text darf höchstens 1024 Zeichen lang sein.",
    footerMax: "Die Fußzeile darf höchstens 60 Zeichen lang sein.",
    buttonTextRequired: "Der Button-Text ist erforderlich.",
    buttonTextMax: "Höchstens 25 Zeichen.",
    phoneInvalid: "PHONE_NUMBER muss im Format E.164 sein (z. B. +34123456789).",
    urlInvalid: "Die URL muss mit http:// oder https:// beginnen",
    loadDetail: "Die Details der Vorlage konnten nicht geladen werden.",
    save: "Fehler beim Speichern der Vorlage.",
    deleteFailed: "Die Vorlage konnte nicht gelöscht werden.",
  },
  duplicate: {
    defaultBody: "Kopie der Vorlage. Bearbeiten Sie den Inhalt. Danke {{1}}.",
  },
};
